import PollsHome from './PollsHome';

export default PollsHome;
